import React, { useEffect, useReducer } from 'react';
import { Link } from 'react-router-dom';
import { 
  Typography, 
  List, 
  ListItem, 
  ListItemText, 
  CircularProgress, 
  Container, 
  Paper, 
  Box 
} from '@mui/material';

const initialState = {
  isLoading: true,
  data: [],
  search: '',
  searchData: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case 'SEARCH_INPUT':
      return { ...state, search: action.payload };
    case 'SEARCH_DATA':
      return { ...state, searchData: action.payload };
    default:
      throw new Error('Ação desconhecida');
  }
};

function AutoresLista() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const apiUrl = process.env.REACT_APP_API_URL || '/api';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/autores`);
        if (!response.ok) {
          throw new Error('Erro ao buscar os autores');
        }
        const data = await response.json();
        dispatch({ type: 'SET_DATA', payload: data });
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, [apiUrl]);

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      
      <Typography 
  variant="h4" 
  gutterBottom 
  align="center" 
  fontWeight="bold" 
  sx={{ 
    color: '#800020',  // Cor vinho
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'  // Sombra preta
  }}
>
  Lista de Autores
</Typography>

        {state.isLoading ? (
          <Box display="flex" justifyContent="center" my={3} bgcolor="rgba(0, 0, 0, 0.2)">
          <CircularProgress size={50} />
          </Box>
        ) : (
          <List sx={{ mt: 2 }}>
            {state.data.map((autor) => (
             <ListItem 
             key={autor._id} 
             component={Link} 
             to={`/Autores/${autor._id}`} 
             sx={{
               backgroundColor: '#f5f5f5',
               borderRadius: 2,
               my: 1,
               boxShadow: 1,
               transition: 'all 0.3s ease',
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'center',  // Centraliza o conteúdo
               textAlign: 'center',  // Centraliza o texto
               '&:hover': { 
                 backgroundColor: '#e0e0e0', 
                 transform: 'scale(1.02)' 
               }
             }}
           >
             <ListItemText 
  primary={autor.nome} 
  primaryTypographyProps={{ 
    fontWeight: 'bold', 
    fontSize: '1.2rem', 
    color: "#d4af37",  // Cor amarela
    fontFamily: 'Poppins, sans-serif',  // Fonte Poppins
   }} 
/>
            </ListItem>
           
            ))}
          </List>
        )}
     
    </Container>
  );
}

export default AutoresLista;
